import React from 'react'
import '@/styles/components/account-status-banner.css'

interface OrderBeingPreparedBannerProps {
  /** Show only while the customer is still awaiting their first delivery. */
  show: boolean
}

/**
 * A welcoming note for a brand-new customer whose first delivery hasn't happened
 * yet (FEDEV-544). Reuses the account-status-banner styling with a friendly
 * "preparing" variant. It sits above the dashboard and goes away on its own once
 * the first delivery has been made.
 */
const OrderBeingPreparedBanner: React.FC<OrderBeingPreparedBannerProps> = ({ show }) => {
  if (!show) return null

  return (
    <div className="account-status-banner preparing" role="status">
      <div className="account-status-banner-icon">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
        </svg>
      </div>
      <div className="account-status-banner-content">
        <h4 className="account-status-banner-title">Your order is being prepared</h4>
        <p className="account-status-banner-message">
          Thanks for joining McQueens Dairies! We're getting everything ready for
          your first delivery. We look forward to delivering to you soon!
        </p>
      </div>
    </div>
  )
}

export default OrderBeingPreparedBanner
